// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.score-card-container {
    width: 86%;
    display: flex;
    flex-direction: column;
    padding: 20px 20px 10px;
    background-color: #F5F5F5;
    margin-bottom: 20px;
    border-radius: 5px;
}

.score-card-title {
    width: 100%;
    text-align: center;
    color: #1F6137;
    font-size: 18px;
    margin: 0 0 10px;
}

.score-left-card {
    padding: 2.5%;
    width: 43%;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    background-color: #fff;
}

.score-right-card {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    width: 48%;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    background-color: #fff;
}

.score_count_container {
    border: #9e9e9e solid 2px;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    margin-right: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center
}

.score-summary-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 160px;
}

.score_count_container span {
    font-size: 22px;
}

.score-card-circle-divider {
    width: 50px;
    height: 2px;
    background-color: #212121;
    margin-top: 6px;
    margin-bottom: 6px
}

.score-card-result-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px
}

.score-card-option-text {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 40%;
}

.score-card-option-separator {
    width: 100%;
    height: 1px;
    background-color: #eeeeee;
    margin-top: 6px
}

.score-card-option-circle-indicator {
    border: 3px solid;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    margin: 0 5px
}

.score-card-correct-answer-percentage {
    width: 30%;
    text-align: center
}

.score-card-correct-answer-count {
    width: 30%;
    text-align: right;
}

.circle-wrap {
    margin: 10px;
    width: 100px;
    height: 100px;
    background: #e6e2e7;
    border-radius: 50%;
}

.circle-wrap .circle .mask,
.circle-wrap .circle .fill {
    width: 100px;
    height: 100px;
    position: absolute;
    border-radius: 50%;
}

.circle-wrap .circle .mask {
    clip: rect(0px, 100px, 100px, 50px);
}

.circle-wrap .circle .mask .fill {
    clip: rect(0px, 50px, 100px, 0px);
    background-color: #FF8038;
}

.circle-wrap .circle .mask.full,
.circle-wrap .circle .fill {
    animation: fill ease-in-out 1s;
    transform: rotate(90deg);
}

@keyframes fill {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(90deg);
    }
}

.circle-wrap .inside-circle {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background: #fff;
    line-height: 90px;
    text-align: center;
    margin-top: 5px;
    margin-left: 5px;
    position: absolute;
    z-index: 100;
    font-weight: 600;
    font-size: 18px;
}


.radialProgressBar {
    border-radius: 50%;
    -webkit-transform: translate(50%, 50%);
    transform: translate(50%, 50%);
    width: 100px;
    height: 100px;
    display: flex;
    background: #ddd;
    margin: 20px;
}

.radialProgressBar .overlay {
    border-radius: 50%;
    width: 90px;
    height: 90px;
    margin: auto;
    background: #fff;
    text-align: center;
}

.progress-10 {
    background-image: -webkit-linear-gradient(90deg, #ddd 50%, transparent 50%), -webkit-linear-gradient(left, #1F6137 50%, #ddd 50%);
    background-image: linear-gradient(54deg, #ddd 50%, transparent 50%), linear-gradient(90deg, #1F6137 50%, #ddd 50%);
}

@media screen and (max-width: 600px) {
    .score-card-container {
        background-color: #fff;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
    }

    .score-left-card {
        width: 95%;
        background-color: transparent;
        box-shadow: none
    }

    .score-right-card {
        width: 100%;
        background-color: transparent;
        box-shadow: none;
        height: auto;
    }

    .score_count_container {
        width: 70px;
        height: 70px;
    }

    .score_count_container span {
        font-size: 16px;
    }

    .score-card-circle-divider {
        width: 35px;
    }

    .score-card-title {
        font-size: 14px;
        margin: 0;
    }

    .score-summary-container {
        flex-direction: column-reverse;
        height: auto;
    }
}

@media print {
    .score-card-container {
        width: 94%;
        max-width: 94%;
    }

    .score-summary-container {
        flex-direction: row;
    }
}
`, "",{"version":3,"sources":["webpack://./src/answer-sheet/css/score-card.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,0CAA0C;IAC1C,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,UAAU;IACV,0CAA0C;IAC1C,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;;IAEI,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;;AAGA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iIAAiI;IACjI,kHAAkH;AACtH;;AAEA;IACI;QACI,sBAAsB;QACtB,0CAA0C;IAC9C;;IAEA;QACI,UAAU;QACV,6BAA6B;QAC7B;IACJ;;IAEA;QACI,WAAW;QACX,6BAA6B;QAC7B,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,8BAA8B;QAC9B,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".score-card-container {\n    width: 86%;\n    display: flex;\n    flex-direction: column;\n    padding: 20px 20px 10px;\n    background-color: #F5F5F5;\n    margin-bottom: 20px;\n    border-radius: 5px;\n}\n\n.score-card-title {\n    width: 100%;\n    text-align: center;\n    color: #1F6137;\n    font-size: 18px;\n    margin: 0 0 10px;\n}\n\n.score-left-card {\n    padding: 2.5%;\n    width: 43%;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);\n    border-radius: 5px;\n    background-color: #fff;\n}\n\n.score-right-card {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-evenly;\n    width: 48%;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);\n    border-radius: 5px;\n    background-color: #fff;\n}\n\n.score_count_container {\n    border: #9e9e9e solid 2px;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    margin-right: 25px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center\n}\n\n.score-summary-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    height: 160px;\n}\n\n.score_count_container span {\n    font-size: 22px;\n}\n\n.score-card-circle-divider {\n    width: 50px;\n    height: 2px;\n    background-color: #212121;\n    margin-top: 6px;\n    margin-bottom: 6px\n}\n\n.score-card-result-row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-top: 10px\n}\n\n.score-card-option-text {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    width: 40%;\n}\n\n.score-card-option-separator {\n    width: 100%;\n    height: 1px;\n    background-color: #eeeeee;\n    margin-top: 6px\n}\n\n.score-card-option-circle-indicator {\n    border: 3px solid;\n    border-radius: 50%;\n    width: 15px;\n    height: 15px;\n    margin: 0 5px\n}\n\n.score-card-correct-answer-percentage {\n    width: 30%;\n    text-align: center\n}\n\n.score-card-correct-answer-count {\n    width: 30%;\n    text-align: right;\n}\n\n.circle-wrap {\n    margin: 10px;\n    width: 100px;\n    height: 100px;\n    background: #e6e2e7;\n    border-radius: 50%;\n}\n\n.circle-wrap .circle .mask,\n.circle-wrap .circle .fill {\n    width: 100px;\n    height: 100px;\n    position: absolute;\n    border-radius: 50%;\n}\n\n.circle-wrap .circle .mask {\n    clip: rect(0px, 100px, 100px, 50px);\n}\n\n.circle-wrap .circle .mask .fill {\n    clip: rect(0px, 50px, 100px, 0px);\n    background-color: #FF8038;\n}\n\n.circle-wrap .circle .mask.full,\n.circle-wrap .circle .fill {\n    animation: fill ease-in-out 1s;\n    transform: rotate(90deg);\n}\n\n@keyframes fill {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(90deg);\n    }\n}\n\n.circle-wrap .inside-circle {\n    width: 90px;\n    height: 90px;\n    border-radius: 50%;\n    background: #fff;\n    line-height: 90px;\n    text-align: center;\n    margin-top: 5px;\n    margin-left: 5px;\n    position: absolute;\n    z-index: 100;\n    font-weight: 600;\n    font-size: 18px;\n}\n\n\n.radialProgressBar {\n    border-radius: 50%;\n    -webkit-transform: translate(50%, 50%);\n    transform: translate(50%, 50%);\n    width: 100px;\n    height: 100px;\n    display: flex;\n    background: #ddd;\n    margin: 20px;\n}\n\n.radialProgressBar .overlay {\n    border-radius: 50%;\n    width: 90px;\n    height: 90px;\n    margin: auto;\n    background: #fff;\n    text-align: center;\n}\n\n.progress-10 {\n    background-image: -webkit-linear-gradient(90deg, #ddd 50%, transparent 50%), -webkit-linear-gradient(left, #1F6137 50%, #ddd 50%);\n    background-image: linear-gradient(54deg, #ddd 50%, transparent 50%), linear-gradient(90deg, #1F6137 50%, #ddd 50%);\n}\n\n@media screen and (max-width: 600px) {\n    .score-card-container {\n        background-color: #fff;\n        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);\n    }\n\n    .score-left-card {\n        width: 95%;\n        background-color: transparent;\n        box-shadow: none\n    }\n\n    .score-right-card {\n        width: 100%;\n        background-color: transparent;\n        box-shadow: none;\n        height: auto;\n    }\n\n    .score_count_container {\n        width: 70px;\n        height: 70px;\n    }\n\n    .score_count_container span {\n        font-size: 16px;\n    }\n\n    .score-card-circle-divider {\n        width: 35px;\n    }\n\n    .score-card-title {\n        font-size: 14px;\n        margin: 0;\n    }\n\n    .score-summary-container {\n        flex-direction: column-reverse;\n        height: auto;\n    }\n}\n\n@media print {\n    .score-card-container {\n        width: 94%;\n        max-width: 94%;\n    }\n\n    .score-summary-container {\n        flex-direction: row;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
